<template>
  <basic-portlet title="Artworks" icon="la la-camera-retro">
    <artwork-list v-model="selected_artwork" allow-editing show-names />
  </basic-portlet>
</template>

<script>

import ArtworkList from "VueComponents/ArtworkList";

export default {
  components: {
    ArtworkList,
  },
  data: () => ({ selected_artwork: null }),
};
</script>
